import React from 'react';

const PackageImages = ({ images, title }) => {
  const extraImages = images.slice(2);
  
  if (extraImages.length === 0) return null;

  return (
    <div className="extra-images">
      {extraImages.map((img, index) => (
        <img 
          key={index} 
          src={img} 
          alt={`${title} ${index + 1}`}
          onError={(e) => e.target.src = '/img/datlogoA.png'}
        />
      ))}
    </div>
  );
};

export default PackageImages;